export default {
  CategoryComment: {
    generalCategory: {
      displayText: 'Reference',
      value: 'GENERAL'
    },
    chargeCategory: {
      displayText: 'Charge'
    }
  },
  resolveText: 'Resolved',
  tabsText: {
    preAudit: 'Pre audit',
    concurrent: 'Concurrent'
  },
  managementComments: {
    textDisplayButtonAddComment: 'General comment',
    addCommentAccount: 'Add comment to account',
    addCommentCharge: 'Add comment to charge',
    editComment: 'Edit comment',
    placeHolderValue: 'Add Comment',
    textButtons: {
      accept: 'Accept',
      cancel: 'Cancel',
      delete: 'Delete'
    },
    deleteConfirmation: {
      title: 'Delete Audit Comment',
      message: 'Are you sure you want to delete this comment? This action cannot be undone and will be logged in the audit history.',
      cancel: 'Cancelar',
      confirm: 'Delete'
    },
    alertMessages: {
      createdComment: 'The comment was successfully saved',
      editComment: 'The comment was successfully edited',
      deleteComment: 'The comment was successfully deleted',
      errorCommentMissing: 'Please enter a comment before saving',
      errorDefault: 'An error occurred while managing the comment'
    }
  }
}
